import React from "react";

export default function Navbar() {
  return (
    <nav className="bg-white shadow fixed w-full top-0 z-50">
      <div className="max-w-7xl mx-auto px-6 py-4 flex justify-between items-center">
        {/* Logo */}
        <div className="flex items-center space-x-2">
          <i className="fas fa-link text-blue-600 text-xl"></i>
          <span className="text-xl font-bold text-blue-600">BenefitChain</span>
        </div>

        {/* Navigation Links */}
        <div className="hidden md:flex items-center space-x-6">
          <a href="#problem" className="text-sm text-gray-700 hover:text-blue-600 transition-colors">
            Problem
          </a>
          <a href="#solution" className="text-sm text-gray-700 hover:text-blue-600 transition-colors">
            Solution
          </a>
          <a href="#architecture" className="text-sm text-gray-700 hover:text-blue-600 transition-colors">
            Architecture
          </a>
          <a href="#stakeholders" className="text-sm text-gray-700 hover:text-blue-600 transition-colors">
            Stakeholders
          </a>
          <a href="#compliance" className="text-sm text-gray-700 hover:text-blue-600 transition-colors">
            Compliance
          </a>
          <a href="#pilot" className="text-sm text-gray-700 hover:text-blue-600 transition-colors">
            Pilot
          </a>
        </div>
      </div>
    </nav>
  );
} 